import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

import mpimg1 from '../img/Master-Planning/11.jpg'
import mpimg2 from '../img/Master-Planning/22.jpg'
import mpimg3 from '../img/Master-Planning/33.jpg'

import arct1 from '../img/Architecture/01.jpg'
import arct2 from '../img/Architecture/02.jpg'
import arct3 from '../img/Architecture/03.jpg'

import id1 from '../img/Interior-Design/1.jpg'
import id2 from '../img/Interior-Design/2.jpg'

import as1 from '../img/Allied-Services/a-s1.jpg'
import as2 from '../img/Allied-Services/a-s2.jpg'
import as3 from '../img/Allied-Services/a-s3.jpg'

const Services = () => {
	return (
		<>
			<section className="section p-t-100 p-b-65" id="about-banner">
				<div className="container">
					<div className="page-heading">
						<h4 className="about_t">Services</h4>
					</div>
				</div>
			</section>

			<section className="company1">
				<div className="container">
					<div className="row">
						<div className="col-lg-7">
							<div className="con-d">
								<h2>Master Planning</h2>
								<p className="t-s-j">
									We specialize in providing comprehensive Master Planning
									Design Services, delivering strategic solutions that shape
									sustainable, functional, and aesthetically pleasing
									environments. Our expert team integrates urban planning,
									landscape architecture, and infrastructure design to create
									harmonious spaces that cater to community needs while
									preserving the natural environment. We emphasize a holistic
									approach, considering economic, social, and environmental
									factors to ensure long-term viability and success. Our
									customized plans address unique project requirements,
									delivering innovative solutions that align with our clients’
									vision and goals.
								</p>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="servicesboxs mt-20 ">
								<Swiper
									spaceBetween={30}
									centeredSlides={true}
									loop={true}
									autoplay={{
										delay: 2500,
										disableOnInteraction: false,
									}}
									modules={[Autoplay]}
									className="mySwiper"
								>
									<SwiperSlide>
										<img src={mpimg1} alt="mp" />
									</SwiperSlide>
									<SwiperSlide>
										<img src={mpimg2} alt="mp" />
									</SwiperSlide>
									<SwiperSlide>
										<img src={mpimg3} alt="mp" />
									</SwiperSlide>
								</Swiper>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className="company1 company2" id='m-t-12'>
				<div className="container">
					<div className="row">
						<div className="col-lg-7">
							<div className="con-d">
								<h2>Architecture</h2>
								<p className="t-s-j">
									We offer comprehensive Architectural Design Services,
									specializing in residential, commercial, and hospitality
									projects while catering to a wide range of other sectors. Our
									approach combines creativity, functionality, and
									sustainability to deliver designs that enhance the user
									experience and meet client expectations. With a deep
									understanding of design principles and a passion for
									innovation, we craft unique and inspiring spaces that reflect
									the distinct character of each project. Our team’s expertise
									ensures seamless project execution, resulting in impactful,
									high-quality architectural solutions.
								</p>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="servicesboxs mt-20 ">
								<Swiper
									spaceBetween={30}
									centeredSlides={true}
									loop={true}
									autoplay={{
										delay: 2500,
										disableOnInteraction: false,
									}}
									modules={[Autoplay]}
									className="mySwiper"
								>
									<SwiperSlide>
										<img src={arct1} alt="mp" />
									</SwiperSlide>
									<SwiperSlide>
										<img src={arct2} alt="mp" />
									</SwiperSlide>
									<SwiperSlide>
										<img src={arct3} alt="mp" />
									</SwiperSlide>
								</Swiper>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className="company1">
				<div className="container">
					<div className="row">
						<div className="col-lg-7">
							<div className="con-d">
								<h2>Interior Design</h2>
								<p className="t-s-j">
									We offer exceptional Interior Design Services that transform
									spaces into functional, aesthetically pleasing environments
									tailored to meet individual needs and preferences. Our team
									combines creativity, practicality, and attention to detail to
									craft interiors that reflect the client’s personality and
									vision. Whether designing for residential, commercial, or
									hospitality projects, we emphasize comfort, style, and
									seamless functionality. From conceptualization to execution,
									we ensure each element harmonizes to create an inviting and
									inspiring atmosphere. Our designs elevate spaces, enhancing
									the experience of those who live, work, or relax within them.
								</p>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="servicesboxs mt-20 ">
								<Swiper
									spaceBetween={30}
									centeredSlides={true}
									loop={true}
									autoplay={{
										delay: 2500,
										disableOnInteraction: false,
									}}
									modules={[Autoplay]}
									className="mySwiper"
								>
									<SwiperSlide>
										<img src={id1} alt="mp" />
									</SwiperSlide>
									<SwiperSlide>
										<img src={id2} alt="mp" />
									</SwiperSlide>
								</Swiper>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className=" m-b-10 company1 company2">
				<div className="container">
					<div className="row">
						<div className="col-lg-7">
							<div className="con-d">
								<h2>Allied Services</h2>
								<p className="t-s-j">
									We offer a comprehensive range of Allied Services to support
									Master Planning, Architecture, and Interior Design. Our
									expertise includes Structural Design, MEP Design, and
									Landscape Design, ensuring cohesive and efficient project
									delivery. Through strong collaborations with specialized
									consultants who are leaders in their respective fields, we
									bring in expert knowledge whenever needed. This approach
									enables us to address complex challenges with precision,
									providing tailored solutions that meet project requirements
									seamlessly. Our commitment to excellence ensures high-quality
									results, delivering environments that are functional,
									sustainable, and visually appealing.
								</p>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="servicesboxs mt-20 ">
								<Swiper
									spaceBetween={30}
									centeredSlides={true}
									loop={true}
									autoplay={{
										delay: 2500,
										disableOnInteraction: false,
									}}
									modules={[Autoplay]}
									className="mySwiper"
								>
									<SwiperSlide>
										<img src={as1} alt="mp" />
									</SwiperSlide>
									<SwiperSlide>
										<img src={as2} alt="mp" />
									</SwiperSlide>
									<SwiperSlide>
										<img src={as3} alt="mp" />
									</SwiperSlide>
								</Swiper>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

export default Services